<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.52013 40L5.86662 38.8031L3.03095 36.2825L6.39621 33.2911L11.5379 37.7782L20.9125 29.445L22.1632 30.5568L23.5097 29.3599L20.336 26.4971L24.6628 22.651L23.3651 21.4525L19.0384 25.2985L14.0395 20.8982L18.3663 17.0521L17.0198 15.8553L12.693 19.7013L9.47235 16.8385L8.12586 18.0354L9.37659 19.1471L0 27.5221L5.09693 32.0511L0.338257 36.2827L4.52013 40ZM10.7209 20.3842L19.5677 28.2482L11.5377 35.3843L2.69279 27.5221L10.7209 20.3842Z"
      fill="#0F285B"
    />
    <path
      d="M28.4621 2.22204L19.0874 10.5552L17.8367 9.4434L16.4902 10.6403L30.5276 23.1618L31.8741 21.9649L30.6234 20.8531L40 12.4781L34.9031 7.94916L39.6617 3.71918L35.4796 0L34.1331 1.24027L36.9688 3.76089L33.6035 6.75227L28.4621 2.22204ZM29.2789 19.6143L20.4321 11.7521L28.4622 4.616L37.307 12.4782L29.2789 19.6143Z"
      fill="#0F285B"
    />
  </svg>
</template>
